import React from "react";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform:translateY(-10%);
  }

  to {
    opacity: 1;
    transform:translateY(0%)
  }
`;

const Fade = styled.div`
  display: inline-block;
  visibility: "hidden";
  animation: ${fadeIn} 2s linear;
  transition: visibility 2s linear;
`;
const LogoSvg = styled.svg`
  width: 18.75rem;
  @media (min-width: 64rem) {
    width: 25rem;
  }
`;

Array.from(document.getElementsByClassName("path")).forEach(pathElement => {
  pathElement.setAttribute('style', 'stroke-dasharray:'+pathElement.getTotalLength()+';stroke-dashoffset:'+pathElement.getTotalLength())
})

const Path = () => (
  <LogoSvg
    viewBox="0 0 400 291"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMaxYMax meet"
  >
    <path
      d="M200.56 204.725C207.93 202.882 214.932 197.109 214.932 185.809C214.932 160.996 186.312 161.61 186.312 161.61H157.692V247.594H186.312C192.085 247.594 216.16 246.488 216.16 222.904C216.16 222.904 216.774 208.041 200.56 204.725ZM171.941 175.859H186.312C186.312 175.859 200.56 175.245 200.56 186.791C200.56 197.478 186.312 197.478 186.312 197.478H171.941V175.859ZM186.312 233.345H171.941V211.849H186.312C186.312 211.849 201.789 210.989 201.789 222.536C201.789 231.871 192.331 233.345 186.312 233.345Z"
      fill="white"
    />
    <path
      d="M282.673 247.594L248.281 159.154L214.011 247.594H282.673ZM248.281 195.39L262.204 234.194H234.246L248.281 195.39Z"
      fill="white"
    />
    <path
      d="M350.24 247.594L326.902 210.252C335.255 207.919 345.818 201.9 345.818 186.668C345.818 161.61 317.076 161.61 317.076 161.61H288.456V175.982L302.09 197.478H288.456V247.594H302.827V211.726H311.057L333.412 247.594H350.24ZM305.529 175.982H317.076C317.076 175.982 331.447 175.982 331.447 186.668C331.447 195.144 322.726 196.986 318.918 197.355L305.529 175.982Z"
      fill="white"
    />
    <path
      d="M400 161.61H349.639V174.754H367.695V247.594H381.944V174.754H400V161.61Z"
      fill="white"
    />
    <path
      d="M18.7344 156.59C28.401 156.59 37.3833 150.31 37.3833 138.781C37.3833 131.64 33.9615 125.618 27.6311 122.693C23.3539 120.714 19.1621 120.714 18.7344 120.714C14.2861 120.714 10.0088 118.047 10.0088 113.057C10.0088 107.464 14.0294 104.711 18.7344 104.711C23.2683 104.711 27.1179 106.948 27.289 111.938H37.2122C37.0411 101.7 29.0854 94.6453 18.7344 94.6453C9.0678 94.6453 0 101.614 0 113.057C0 120.198 3.50736 125.532 9.75217 128.457C14.115 130.436 18.2211 130.436 18.7344 130.436C22.755 130.608 27.46 133.705 27.46 138.781C27.46 143.513 23.3539 146.524 18.7344 146.524C14.2861 146.524 10.1799 144.029 10.0088 139.039H0C0.171091 150.31 8.38344 156.332 18.7344 156.59Z"
      fill="white"
    />
    <path
      d="M153.523 95.4196H143.343L121.529 142.308L98.7742 95.4196H88.5943V155.73H98.6031V117.961L116.91 155.73H126.32L143.514 118.735V155.73H153.523V95.4196Z"
      fill="white"
    />
    <path
      d="M158.066 95.5057V131.554C158.066 132.156 158.152 137.921 161.06 143.771C165.167 152.03 172.951 156.59 182.96 156.59C192.969 156.59 200.753 152.03 204.86 143.771C207.768 137.921 207.854 132.156 207.854 131.554V95.5057H158.066ZM195.792 139.555C193.396 144.287 189.205 146.524 182.96 146.524C176.801 146.524 172.609 144.287 170.128 139.555C168.075 135.684 167.99 131.554 167.99 131.554V105.572H197.93V131.468C197.93 131.554 197.845 135.684 195.792 139.555Z"
      fill="white"
    />
    <path
      d="M252.365 105.572V95.5057H212.415V155.73H252.365V145.664H222.424V130.608H247.318V120.628H222.424V105.572H252.365Z"
      fill="white"
    />
    <path
      d="M266.305 145.664V95.5057H256.296V155.73H288.462V145.664H266.305Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M84.5206 155.73L60.5679 93.785L36.7008 155.73H84.5206ZM60.5679 119.165L50.9079 146.336H70.2279L60.5679 119.165Z"
      fill="white"
    />
    <path
      id="triangle"
      d="M214.973 9.15525C208.451 -2.72519 191.383 -2.72515 184.861 9.15524L144.39 82.8768H155.797L193.627 13.9675C196.351 9.00408 203.482 9.00408 206.207 13.9675L244.036 82.8768H255.444L214.973 9.15525ZM352.348 259.398H340.941L346.923 270.296C349.549 275.078 346.089 280.925 340.633 280.925H59.2001C53.7448 280.925 50.2847 275.078 52.9099 270.296L109.452 167.3H98.044L44.1439 265.484C37.8602 276.931 46.1422 290.925 59.2001 290.925H340.633C353.691 290.925 361.973 276.931 355.689 265.484L352.348 259.398Z"
      fill="url(#gradient)"
    />
    <defs>
      <linearGradient
        id="gradient"
        x="150"
        y="300"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00C853">
          <animate
            dur="2s"
            attributeName="offset"
            fill="freeze"
            from="0"
            to="1"
          />
        </stop>
        <stop offset="0" stopColor="transparent">
          <animate
            dur="2s"
            attributeName="offset"
            fill="freeze"
            from="0"
            to="1"
          />
        </stop>
      </linearGradient>
      {/* <linearGradient
        id="gradient"
        x1="199.917"
        y1="0.244934"
        x2="199.917"
        y2="290.925"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00C853" />
        <stop offset="1" stopColor="#9EED42" />
      </linearGradient> */}
    </defs>
  </LogoSvg>
);

const Logo = ({ animated }) => {
  return animated ? (
    <Fade>
      <Path />
    </Fade>
  ) : (
    <Path />
  );
};

export default Logo;
